import React from "react";

import BoxWithLabel from "../../box/BoxWithLabel";

import { useTranslation } from "react-i18next";

import IconButtonWithTooltip from "../../button/IconButtonWithTooltip";

import useDialog from "../../../hooks/useDialog";
import EquipmentUsageRecalculateDialog from "../../dialog/EquipmentUsageRecalculateDialog";

import TungstenIcon from "@mui/icons-material/Tungsten";

import useCheckPermission from "../../../hooks/usePermission";
import { EDIT_COUNTER_USAGE_PERMISSION } from "../../../helpers/constants";

const EquipmentUsageForm = (props) => {
  const { t } = useTranslation();

  const [openDialog, onOpenDialog, onCloseDialog] = useDialog();

  const [hasPermissionToEditUsage] = useCheckPermission(
    EDIT_COUNTER_USAGE_PERMISSION
  );

  return (
    <BoxWithLabel
      label={t("form.meter_passport.equipment_usage")}
      boxStyle={{ height: "100%" }}
      style={{ height: "100%", display: "flex", justifyContent: "center" }}
    >
      <IconButtonWithTooltip
        title={t("form.meter_passport.equipment_usage")}
        fontSize={"500%"}
        onClick={onOpenDialog}
      >
        <TungstenIcon fontSize="inherit" color="primary" />
      </IconButtonWithTooltip>
      {hasPermissionToEditUsage && openDialog && (
        <EquipmentUsageRecalculateDialog
          equipmentId={props.equipmentId}
          onClose={onCloseDialog}
          open={openDialog}
        />
      )}
    </BoxWithLabel>
  );
};

export default EquipmentUsageForm;
